import { Auth0Provider, type AppState } from '@auth0/auth0-react';
import type { ReactElement, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { env } from '@/lib/env';

interface Props {
  children: ReactNode;
}

export function Auth0ProviderWithNavigate({ children }: Props): ReactElement {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState): void => {
    const target = appState?.returnTo ?? '/dashboard';
    void navigate(target, { replace: true });
  };

  return (
    <Auth0Provider
      domain={env.VITE_AUTH0_DOMAIN}
      clientId={env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: env.VITE_AUTH0_REDIRECT_URI,
        audience: env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="memory"
      useRefreshTokens
      useRefreshTokensFallback={false}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}
